import { apiClient } from "./ApiClient";

const DOWNLOAD_API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v1/download`;

export default {
    downloadUserProfile({ udid, dt_from, dt_to }) {
        return apiClient.get(
          `${DOWNLOAD_API_URL}/profile/${udid}?dt_from=${dt_from}&dt_to=${dt_to}`,
           { file_name: 'user_profile' }, { responseType: 'blob'}
        );
    },
};
